import { defineComponent } from 'vue'
import type { ExtractPropTypes } from 'vue'


export const edittableColumnIndexProps = () => ({})

export type QuerytableColumnIndexProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnIndexProps>>>

export default defineComponent({
  name: 'OQuerytableColumnIndex',
  inheritAttrs: false,
  props: edittableColumnIndexProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
